<template>
  <div class="mypage-cancel-paid-plan-edit-page">
    <sub-header-section :pageTitle="$tc('CancelPaidPlan.EditPage.title')" :backLink="'/mypage'" />
    <mypage-cancel-paid-plan-edit-pane />
    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypageCancelPaidPlanEditPane from '@/components/MypageCancelPaidPlanPage/MypageCancelPaidPlanEditPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

/**
 * アプリ版: 有料会員解約ページ
 */
export default defineComponent({
  name: 'MypageCancelPaidPlanEditPage',
  components: {
    GlobalNavigationPane,
    SubHeaderSection,
    MypageCancelPaidPlanEditPane,
  },
})
</script>
